import { render, staticRenderFns } from "./editorDetail.vue?vue&type=template&id=262c5258&scoped=true&"
import script from "./editorDetail.vue?vue&type=script&lang=js&"
export * from "./editorDetail.vue?vue&type=script&lang=js&"
import style0 from "./editorDetail.vue?vue&type=style&index=0&id=262c5258&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262c5258",
  null
  
)

export default component.exports